import React from 'react';
import styled from 'styled-components';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

/**
 * @param {Object} props
 * @returns
 */
export default function Summary({ overview }) {
  const items = [
    {
      title: `所属环境：${overview.envName}`,
      info: <Info>集群备注：{overview.desc}</Info>,
    },
    {
      title: '部署组件数',
      info: overview.componentNum || 0,
      unit: '个',
    },
    {
      title: '部署机器数',
      info: overview.hostNum || 0,
      unit: '个',
    },
  ];
  return <SummaryPanel shadow items={items} />;
}

const Info = styled.div`
  color: #8f959f;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`;
